import script from "./CreateHzbaCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateHzbaCard.vue?vue&type=script&setup=true&lang=ts"

import "./CreateHzbaCard.vue?vue&type=style&index=0&id=ce9f50c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9f50c8"]])

export default __exports__